.ndis-classification-step{display:flex;flex-direction:column;gap:24px;max-width:720px}.ndis-classification-hint{font-size:13px;color:#707070;margin:-16px 0 0}
/*# sourceMappingURL=ndis-classification-step.component-DKVGCVM6.css.map */
